module.exports = __webpack_public_path__ + "media/cuu/logo_ensech_cintillo-e979d01f.png";